/*
 * @Author: RYL
 * @Description: 云监测设备列表接口api
 * @Date: 2020-10-12 11:38:57
 * @LastEditTime: 2021-03-04 14:34:29
 */
import http from '@/axios/http'

export function getDeviceList(data) {
  return http({
    url: '/api2/device/list',
    method: 'post',
    data,
  })
}
// 条件搜索设备
export function queryDevices(data) {
  return http({
    // url: '/api2/device/query',
    url: '/api2/device/list',
    method: 'post',
    data,
  })
}
// 添加设备
export function addDevice(data) {
  return http({
    url: '/api2/device/add',
    method: 'post',
    data,
  })
}

// 删除设备
export function deleteDevice(data) {
  return http({
    url: '/api2/device/del',
    method: 'post',
    data,
  })
}
// 根据分组id查询分组所属设备列表
export function getListByGroup(data) {
  return http({
    url: '/api2/device/group/list',
    method: 'post',
    data,
  })
}

// 开启上行服务
export function openServer(data) {
  return http({
    url: '/api2/deviceConfig/upConfig',
    method: 'post',
    data,
  })
}
 
